// MenuContext.jsx - Context para estado persistente del menú
import React, { createContext, useContext, useState, useCallback } from 'react';

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMenu = useCallback(() => {
        console.log('MenuContext: toggleMenu called, current state:', mobileMenuOpen);
        setMobileMenuOpen(prev => {
            const newState = !prev;
            console.log('MenuContext: new state will be:', newState);
            return newState;
        });
    }, [mobileMenuOpen]);

    const closeMenu = useCallback(() => {
        console.log('MenuContext: closeMenu called');
        setMobileMenuOpen(false);
    }, []);

    const openMenu = useCallback(() => {
        console.log('MenuContext: openMenu called');
        setMobileMenuOpen(true);
    }, []);

    const contextValue = {
        mobileMenuOpen,
        toggleMenu,
        closeMenu,
        openMenu
    };

    console.log('MenuContext Provider render, state:', mobileMenuOpen);

    return (
        <MenuContext.Provider value={contextValue}>
            {children}
        </MenuContext.Provider>
    );
};

export const useMenu = () => {
    const context = useContext(MenuContext);
    if (!context) {
        throw new Error('useMenu debe usarse dentro de MenuProvider');
    }
    return context;
};